<!-- 单属于本科的消息提示 -->
<template>
  <transition name="fade">
    <div class='modal-mask'
         v-if="visible">
      <div class='modal-wrap'>
        <div class='modal-container'>
          <img :src='picOptions.type' />
          <p>{{content}}</p>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import modalSucc from '@/assets/undergraduate/images/modal_succ.png'
import modalError from '@/assets/undergraduate/images/cv_warn.png'
export default {
  name: 'zlr-message-modal',
  components: {},
  data () {
    return {
      modalSucc,
      modalError,
      content: '',
      time: 3000,
      visible: false,
      hasClose: false,
      type: 'success'
    }
  },
  render (createElement) {
    return createElement('div', '你好')
  },
  computed: {
    picOptions () {
      let options = {
        type: '',
        color: ''
      }
      switch (this.type) {
        case 'success':
          options.type = modalSucc
          break
        // case 'warning':
        //   options.type = 'ios-alert'
        //   break
        case 'error':
          options.type = modalError
          break
      }
      return options
    }
  },
  mounted () {
    this.close()
  },
  methods: {
    close () {
      let timeOut = ''
      timeOut = setTimeout(() => {
        clearTimeout(timeOut)
        this.visible = false
      }, this.time)
    }
  }

}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(230, 234, 241, 0.7);
  z-index: 9999;
  .modal-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    .modal-container {
      background: #fff;
      padding: 100px 20px;
      position: relative;
      width: 440px;
      border-radius: 8px;
      img {
        width: 120px;
        height: 120px;
        margin: 0 auto;
      }
      p {
        padding-top: 40px;
        font-size: 30px;
        color: #323c47;
        letter-spacing: 0;
        text-align: center;
      }
    }
  }
}
</style>
